import CurrencyInput from 'react-currency-input-field';
import { FormItemProps } from 'antd';

import { FloatingFormItem } from '..';

export function formatRawValue(value: string) {
  return +value.replace('.', '').replace(',', '.');
}

interface CurrencyFormFieldProps extends FormItemProps {
  disabled?: boolean;
}

function CurrencyFormField(props: CurrencyFormFieldProps) {
  return (
    <FloatingFormItem {...props} valuePropName="value" trigger="onValueChange">
      <CurrencyInput
        disabled={props.disabled}
        intlConfig={{ locale: 'pt-BR', currency: 'BRL' }}
        className="ant-input"
        decimalSeparator=","
        groupSeparator="."
        decimalScale={2}
        step={1}
      />
    </FloatingFormItem>
  );
}

export default CurrencyFormField;
